import * as Types from '../graphql.generated';

import { gql } from '@apollo/client';
export type Links_FragmentFragment = { __typename?: 'Links' } & Pick<
    Types.Links,
    'saveSearch' | 'createAlert'
>;

export const Links_FragmentFragmentDoc = gql`
    fragment LINKS_FRAGMENT on Links {
        saveSearch
        createAlert
    }
`;
